module.exports = __webpack_public_path__ + "img/vioce_call.0e7d689e.png";